import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Input from "../shared/Input";
import { fetchData, fetchFormData, getValueLabel } from "../../utils/options";
import topTost from "../../utils/topTost";
import TextArea from "../shared/TextArea";
import SelectDropdown from "../shared/SelectDropdown";
import { IBaseUrl } from "../..";

const ExpenseCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const today = new Date().toISOString().split("T")[0];
  const [employdata, setemploydata] = useState([]);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [category, setCategory] = useState([]);
  const [description, setDescription] = useState([]);
  const [travelData, setTravelData] = useState({
    travelling_date: today,
    amount: "",
    sectionamount: "",
    including_gst: false,
    travelling_description: "",
    employID: "",
    assigned_to: "",
    IsStatus: false,
    reason: "",
    bill_image: "",
    transaction_id: "",
    expense_category: category,
    payment_settled: false,
    status: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchDetails = async (id) => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("created_by", userId);
    formData.append("moduleId", M_id);
    formData.append("userId", userId);
    try {
      const result = await fetchFormData("expense/getById", formData, "POST");

      if (result && result.data) {
        setTravelData(result.data);
        setTravelData((prev) => ({
          ...prev,
          bill_image: "",
        }));
        setPhotoPreview(result.data.bill_image_url);
      } else {
        console.warn("Data not found.");
        setTravelData({});
      }
    } catch (error) {
      console.error("Failed to fetch details:", error);
      setTravelData({});
    }
  };

  const fetchAllData = async () => {
    const form = new FormData();
    form.append("created_by", userId);
    form.append("moduleId", M_id);
    form.append("userId", userId);

    try {
      const resp = await fetchFormData(
        "list-expense-category-dropdown",
        form,
        "POST"
      );
      if (resp?.data) {
        setCategory(getValueLabel(resp.data, "expense_category", "id"));
      }
    } catch (err) {
      console.error("Error loading categories:", err);
    }
  };

  useEffect(() => {
    fetchAllData();
    if (id) {
      fetchDetails(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!travelData.travelling_description) {
      topTost({ title: "Travel description is required", icon: "error" });
      return;
    }

    if (!travelData.expense_category) {
      topTost({ title: "Expense Category is required", icon: "error" });
      return;
    }
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("created_by", userId);
    formData.append("moduleId", M_id);
    formData.append("branchID", 1);
    formData.append("travelling_date", travelData.travelling_date || "");
    formData.append("amount", travelData.amount || "");
    formData.append("sectionamount", travelData.sectionamount || "");
    formData.append("including_gst", travelData.including_gst ? 1 : 0);
    formData.append(
      "travelling_description",
      travelData.travelling_description || ""
    );
    formData.append("employID", userId || "");
    formData.append("IsStatus", 1);
    formData.append("reason", travelData.reason || "");
    formData.append("expense_category", travelData.expense_category || "");
    // const isValidBase64 = (str) =>
    //   typeof str === "string" && /^data:image\/[a-zA-Z]+;base64,/.test(str);
    if (travelData.bill_image && travelData.bill_image instanceof File) {
      formData.append("bill_image", travelData.bill_image);
    }
    formData.append("transaction_id", travelData.transaction_id || "");
    formData.append("payment_settled", travelData.payment_settled ? 1 : 0);
    formData.append("status", 1);
    formData.append("assigned_to", travelData.assigned_to || "");

    try {
      let res;
      if (id) {
        formData.append("id", id);
        formData.append("userId", userId);
        res = await fetchFormData("expense/update", formData, "POST");
      } else {
        res = await fetchFormData("expense/add", formData, "POST");
      }

      if (res?.message?.includes("successfully")) {
        topTost({
          title: res.message,
          icon: "success",
        });
        navigate(`/master/expense-list?id=${M_id}`);
      } else {
        console.error("Operation failed:", res);
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleExpenseCategoryChange = (opt) => {
    if (opt)
      setTravelData((prev) => ({ ...prev, expense_category: opt.value }));
  };
  const handleChange = (key, value) => {
    setDescription((prev) => ({ ...prev, [key]: value }));
  };
  
  const handlePhotoChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      setTravelData((prev) => ({ ...prev, bill_image: file }));
      reader.onloadend = () => {
        setTravelData({
          ...travelData,
          image: file,
          imageBase64: reader.result,
        });
      };
      reader.onloadend = () => {
        setPhotoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      // If file is removed or canceled
      setTravelData((prev) => ({ ...prev, bill_image: null }));
      setPhotoPreview(null);
    }
  };

  return (
    <div className="col-lg-12">
      <div className="card stretch stretch-full">
        <hr className="mt-0" />
        <div className="card-body general-info">
          <div className="mb-5 d-flex align-items-center justify-content-between">
            <h5 className="fw-bold mb-0 me-4">
              <span className="d-block mb-2">
                {id ? "Edit Expense:" : "Add Expense:"}
              </span>
            </h5>
          </div>

          <form onSubmit={handleSubmit} className="row g-3">
            <div className="row">
              <div className="col-md-6">
                <Input
                  label="Expense Date"
                  name="travelling_date"
                  value={travelData.travelling_date}
                  onChange={(name, value) =>
                    setTravelData((prev) => ({ ...prev, [name]: value }))
                  }
                  placeholder="Select Date"
                  icon="feather-date"
                  type="date"
                  min={today}
                  required
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Amount"
                  name="amount"
                  value={travelData.amount}
                  onChange={(name, value) =>
                    setTravelData((prev) => ({ ...prev, [name]: value }))
                  }
                  placeholder="Enter Amount"
                  icon="feather-dollar-sign"
                  required
                />
              </div>

              <div className="col-md-6">
                <Input
                  label="Transaction ID"
                  name="transaction_id"
                  value={travelData.transaction_id}
                  onChange={(name, value) =>
                    setTravelData((prev) => ({ ...prev, [name]: value }))
                  }
                  placeholder="Enter Transaction ID"
                  icon="feather-hash"
                  required
                />
              </div>

              {id && (
                <>
                  <div className="col-md-6">
                    <Input
                      label="Sanction Amount"
                      name="sectionamount"
                      value={travelData.sectionamount}
                      onChange={(name, value) =>
                        setTravelData((prev) => ({ ...prev, [name]: value }))
                      }
                      placeholder="Enter Sanction Amount"
                      icon="feather-percent"
                    />
                  </div>
             
                </>
              )}

              <div className="col-md-6">
                <Input
                  label="Upload Bill Image"
                  name="bill_image"
                  type="file"
                  onChange={handlePhotoChange}
                  icon="feather-upload"
                />
              </div>

              <div className="col-md-6">
                <TextArea
                  label={
                    <>
                      Travell Description<span className="text-danger">*</span>
                    </>
                  }
                  name="travelling_description"
                  labelId="Description"
                  value={travelData.travelling_description}
                  onChange={(e) =>
                    setTravelData((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                  placeholder="Enter Description"
                  icon="feather-type"
                  required
                />
              </div>

              <div className="col-md-2">
                <label className="fw-semibold">
                  Expense Category:
                  <span className="text-danger">*</span>
                </label>
              </div>

              <div className="col-lg-4">
                <SelectDropdown
                  options={category}
                  selectedOption={
                    category.find(
                      (opt) =>
                        Number(opt.value) ===
                        Number(travelData.expense_category)
                    ) || null
                  }
                  defaultSelect="Select Expense Category"
                  onSelectOption={handleExpenseCategoryChange}
                  value={Number(travelData.expense_category)}
                  icon="feather-user"
                  required={true}
                />
              </div>
              {photoPreview && (
                <img
                  src={photoPreview}
                  alt="Preview"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: 4,
                  }}
                />
              )}
            </div>

            <div className="customButton">
              <button
                type="submit"
                className="btn btn-lg btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ExpenseCreate;
